import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import {Box, Chip, FormControlLabel, FormGroup} from "@mui/material";
import React, {useCallback, useEffect} from "react";
import {getData} from "../util/__fetch";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function FNOUsers({ user, selectedUsers, setSelectedUsers, allUsers, setAllUsers, setErrorMessage, type }) {
  const [localCachedUsers, setLocalCachedUsers] = React.useState(selectedUsers);
  const [localStorageVarName] = React.useState(type === "SELL" ?'fno_selected_users_sell' : 'fno_selected_users_buy');


  // Load selectedUsers from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem(localStorageVarName);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed)) {
          setLocalCachedUsers(parsed);
        }
      } catch {}
    }
  }, [setSelectedUsers]);

  const fetchAllUsers = useCallback((users) => {
    // by default, no users to be marked selected, active flag comes from DB, indicating active users
    // same active flag is used in two ways here
    if (Array.isArray(localCachedUsers) && localCachedUsers.length === 0) {
      const inActivatedUsers = users.map(u => ({...u, active: false}));
      setAllUsers(inActivatedUsers);
      setSelectedUsers(inActivatedUsers);
    }
    else {
      setSelectedUsers(localCachedUsers);
    }
  }, [setAllUsers, setSelectedUsers, localCachedUsers]);

  // Save selectedUsers to localStorage whenever it changes
  useEffect(() => {
    if (selectedUsers) {
      localStorage.setItem(localStorageVarName, JSON.stringify(selectedUsers));
    }
  }, [selectedUsers]);

  useEffect(() => {
    console.log('calling active users')
    getData('/algo-trading/api/fno/active/users', user, fetchAllUsers, setErrorMessage, () => {})
      .then(response => { });
  }, [user, fetchAllUsers, setErrorMessage]);

  function isUserActive(userId) {
    return selectedUsers?.find(us => us?.userId === userId)?.active || false;
  }
  function switchUserStatus(event, userId) {
    function toggleUserStatus(userId, newStatus) {
      setSelectedUsers(selectedUsers.map(us => us.userId === userId ? { ...us, active: newStatus } : us));
    }
    const originalStatus = selectedUsers.find(us => us?.userId === userId)?.active
    toggleUserStatus(userId, !originalStatus)
  }

  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl sx={{ m: 1}} fullWidth>
        <InputLabel id="fno-users">FNO {type} Users</InputLabel>
        <Select
          labelId="fno-users"
          id={`fno-users-multiple-checkbox-${type}`}
          fullWidth
          multiple
          color={type === "SELL" ? "secondary" : "primary"}
          value={selectedUsers?.filter(u => u?.active).map((u) => u.userId)}
          renderValue={(selected) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          <FormGroup sx={{ alignItems: 'flex-start', display: 'flex', flexWrap: 'wrap', ml: 5 }}>
            {allUsers?.map((u) => (
              <MenuItem key={u?.userId} value={u?.userId}>
                <FormControlLabel
                  control={<Checkbox size="medium" checked={isUserActive(u?.userId)} onChange={(e) => switchUserStatus(e, u?.userId)} />}
                  label={`${u?.fullName} (${u?.userId})`} />
              </MenuItem>
            ))}
          </FormGroup>
        </Select>
      </FormControl>
    </Box>
  );
}
